import { useEffect, useState } from 'react';
import isEmpty from 'lodash/isEmpty';
import useDeepCompareEffect from 'use-deep-compare-effect';

import Configuration from 'redpoints-connector-common/helper/Configuration';

import { cast, redirect } from 'redpoints-front-common/helpers';

import { ROUTES } from '../../../../config/constants';

const useShortenerResolutionSetInitialData = ({
  customerId,
  filtersApplied,
  hasFiltersApplied,
  isLoadedDomains,
  queryParams,
  shortenerResolutionFetchDomains,
  shortenerResolutionFetchLinkToResolve,
  shortenerResolutionSetFiltersSelected,
}) => {
  const [isEnableFilterByTenant, setIsEnableFilterByTenant] = useState(null);
  const [isInitialized, setIsInitialized] = useState(false);
  const mustInitialize = !isInitialized && isLoadedDomains;

  const domain = filtersApplied.domain;
  const filterByCustomer =
    filtersApplied.filterByCustomer || !isEnableFilterByTenant;

  const customerIdToFetch = filterByCustomer ? customerId : undefined;

  useEffect(() => {
    const getConfiguration = async () => {
      try {
        const configuration = await Configuration.getJSONConfig();
        setIsEnableFilterByTenant(
          configuration.task?.enableFilterByTenant ?? false
        );
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
      }
    };

    getConfiguration();
  }, []);

  useDeepCompareEffect(() => {
    const mustRedirect =
      !isInitialized &&
      isEnableFilterByTenant === false &&
      cast.bool(queryParams.filterByCustomer, null) === false;

    if (mustRedirect) {
      redirect({
        queryParams: { ...queryParams, filterByCustomer },
        urlRoute: ROUTES.SHORTENER_RESOLUTION,
      });
    }
  }, [filterByCustomer, isEnableFilterByTenant, isInitialized, queryParams]);

  useEffect(() => {
    const mustFetchDomains = !isInitialized && isEnableFilterByTenant != null;

    if (mustFetchDomains) {
      shortenerResolutionFetchDomains({
        customerId: customerIdToFetch,
      });
    }
  }, [
    customerIdToFetch,
    isEnableFilterByTenant,
    isInitialized,
    shortenerResolutionFetchDomains,
  ]);

  useEffect(() => {
    const mustSetInitialFilters = mustInitialize && !hasFiltersApplied;

    if (mustSetInitialFilters) {
      shortenerResolutionSetFiltersSelected({ domain, filterByCustomer });
    }
  }, [
    shortenerResolutionSetFiltersSelected,
    domain,
    filterByCustomer,
    mustInitialize,
    hasFiltersApplied,
  ]);

  const mustFetchLink = mustInitialize && !isEmpty(queryParams);
  useEffect(() => {
    if (mustFetchLink) {
      shortenerResolutionFetchLinkToResolve({
        domainIds: domain?.domainId ? [domain.domainId] : undefined,
        customerId: customerIdToFetch,
      });
    }
  }, [
    customerIdToFetch,
    domain,
    mustFetchLink,
    shortenerResolutionFetchLinkToResolve,
  ]);

  useEffect(() => {
    const mustSetAsInitialized = mustInitialize && hasFiltersApplied;
    if (mustSetAsInitialized) {
      setIsInitialized(true);
    }
  }, [mustInitialize, hasFiltersApplied]);

  return { isEnableFilterByTenant };
};

export default useShortenerResolutionSetInitialData;
